// w9.ts — Patch 015.7. W-9 collection methods.
//
// Cross-project / Heritage org-level — a W-9 is collected once per vendor,
// not per project. See workers/core-os/src/routes/w9.ts.

import { request } from './request'
import type { CreateW9Input, PatchW9Input, W9ListResponse } from './types'

export const w9Api = {
  list: (params?: { status?: string; contractor_id?: string }) => {
    const qs = new URLSearchParams()
    if (params?.status) qs.set('status', params.status)
    if (params?.contractor_id) qs.set('contractor_id', params.contractor_id)
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return request<W9ListResponse>(`/api/w9-records${suffix}`)
  },
  create: (body: CreateW9Input) =>
    request<{ ok: true; id: string; status: string; request_id: string }>(
      '/api/w9-records',
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (w9Id: string, body: PatchW9Input) =>
    request<{
      ok: true
      id: string
      updated: string[]
      superseded_count: number
    }>(`/api/w9-records/${encodeURIComponent(w9Id)}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
}
